export class Marca {
    id: number | null = null;
    ativo?: boolean | null = true;
    nome: string = "";
    dataCadastro: string = "";
    dataUltimaModificacao: string | null = null;
  }
